import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "errPage-container"
};
const _hoisted_2 = {
  class: "list-unstyled"
};
const _hoisted_3 = {
  class: "link-type"
};
const _hoisted_4 = ["src"];
import { reactive, toRefs } from "vue";
import { useRouter } from "vue-router";
import { defineComponent } from "vue";
export default /*@__PURE__*/_defineComponent({
  __name: '401',
  setup(__props) {
    defineComponent({
      name: "Page401"
    });
    const state = reactive({
      errGif: new URL(`../../assets/401_images/401.gif`, import.meta.url).href,
      ewizardClap: "https://wpimg.wallstcn.com/007ef517-bafd-4066-aae4-6883632d9646",
      dialogVisible: false
    });
    const {
      errGif,
      ewizardClap,
      dialogVisible
    } = toRefs(state);
    const router = useRouter();
    function back() {
      router.back();
    }
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_cache[2] || (_cache[2] = _createElementVNode("h1", {
            class: "text-jumbo text-ginormous"
          }, "Oops!", -1)), _cache[3] || (_cache[3] = _createElementVNode("h2", null, "你没有权限去该页面", -1)), _cache[4] || (_cache[4] = _createElementVNode("h6", null, "如有不满请联系你领导", -1)), _createElementVNode("ul", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("li", null, "或者你可以去:", -1)), _createElementVNode("li", _hoisted_3, [_createVNode(_component_router_link, {
            to: "/dashboard"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode(" 回首页 ")])),
            _: 1
          })])])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("img", {
            src: _unref(errGif),
            width: "313",
            height: "428",
            alt: "Girl has dropped her ice cream."
          }, null, 8, _hoisted_4)]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
});